module.exports = __webpack_public_path__ + "img/versions.24f232c4.svg";